<div class="c-inline-note">
  <ng-container [ngSwitch]="noteType">
    <ng-container *ngSwitchCase="InlineNoteEditorType.FOR_LIBRARY">
      <i
        class="fal fa-fw fa-university fa-lg qa-library-note"
        tooltip="Note for library"
        i18n-tooltip="@@inlineNote-tooltip-noteForLibrary"
        aria-hidden="true"
      ></i>
      <span class="sr-only" i18n="@@inlineNote-label-noteForLibrary"
        >Note for library</span
      >
    </ng-container>
    <ng-container *ngSwitchCase="InlineNoteEditorType.FOR_STUDENTS">
      <i
        class="fal fa-fw fa-graduation-cap fa-lg qa-student-note"
        tooltip="Note for students"
        i18n-tooltip="@@inlineNote-tooltip-noteForStudents"
        aria-hidden="true"
      >
      </i>
      <span class="sr-only" i18n="@@inlineNote-label-noteForStudents"
        >Note for students</span
      >
    </ng-container>
    <ng-container *ngSwitchCase="InlineNoteEditorType.PERSONAL">
      <i
        class="fal fa-fw fa-lock fa-lg qa-personal-note"
        tooltip="Personal note"
        i18n-tooltip="@@inlineNote-tooltip-personalNote"
        aria-hidden="true"
      >
      </i>
      <span class="sr-only" i18n="@@inlineNote-label-personalNote"
        >Personal note</span
      >
    </ng-container>
  </ng-container>
  <ng-container *ngIf="note" [ngSwitch]="noteType">
    <div
      *ngSwitchCase="InlineNoteEditorType.PERSONAL"
      [innerHTML]="note | autoLinkUrl"
      class="u-prewrap qa-content"
    ></div>
    <span *ngSwitchDefault class="qa-content">{{ note }}</span>
  </ng-container>
</div>
